import PostPreview from '../components/blog/preview';
import List from '../components/common/list';
import { Container } from '../components/layout/container';
import Layout from '../components/layout/layout';
import { search } from '../lib/api';
import { useTranslation } from '../lib/i18n';

const WaitListInner = ({ questions }) => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className='bg-beige-gradient-1 pb-12'>
        <div className='mx-auto max-w-xl p-8 text-center'>
          <h2>{t('wait-list-title')}</h2>

          <p
            className='pt-2 element-sublink'
            dangerouslySetInnerHTML={{
              __html: t('wait-list-text'),
            }}
          />
        </div>
      </div>
      {questions && (
        <div className='bg-green-gradient-1'>
          <Container className='py-12 text-center'>
            <List component={PostPreview} className='mt-10' items={questions} />
          </Container>
        </div>
      )}
    </Layout>
  );
};

const WaitList = (props) => {
  return <WaitListInner {...props} />;
};

export async function getStaticProps() {
  const questions = (
    await search(`filter=type--blog||tags--Fragen&sort=published--desc&size=3`)
  ).results;

  return {
    props: {
      questions,
    },
  };
}

export default WaitList;
